import forEach from 'lodash/forEach';
import { gatewayObserverCreators } from './registerGatewayObserverCreator';

const configureGatewayObservers = (gateways, { dispatch, getState }) => {
  forEach(gatewayObserverCreators, ([name, createObserver]) => {
    // added it in case if gateway has no observer (i.e. agentActivity)
    if (gateways[name].setObserver) {
      gateways[name].setObserver(createObserver({ dispatch, getState }));
    }
  });
};
export { configureGatewayObservers };
